import Collection from 'ol/Collection';
import Translate from 'ol/interaction/Translate';
import { buildTranslateFeaturesFromSelection, isMapTranslateBlockedEvent } from '@/features/panel-planning/utils/panelMapSelection';

export const PANEL_MAP_BULK_SELECTION_THRESHOLD = 300;

/**
 * Translate 상호작용을 현재 선택 상태에 맞게 재바인딩한다.
 * (꼭짓점 편집 Modify는 패널 플래닝에서 사용하지 않음)
 * @returns {{ modifyInteraction: null, translateInteraction }}
 */
export function applyPanelTranslateModifyBindings(map, options = {}) {
  const {
    groupSelection,
    moduleSelection,
    modifyInteraction: oldModify,
    translateInteraction: oldTranslate,
    bulkThreshold = PANEL_MAP_BULK_SELECTION_THRESHOLD,
    handlers = {},
    assignInteractions
  } = options;

  if (!map) {
    return { modifyInteraction: null, translateInteraction: oldTranslate };
  }

  const groupCount = groupSelection?.getLength() ?? 0;
  if (groupCount > bulkThreshold) {
    if (oldModify) {
      map.removeInteraction(oldModify);
    }
    if (oldTranslate) {
      map.removeInteraction(oldTranslate);
    }
    if (typeof assignInteractions === 'function') {
      assignInteractions({ modifyInteraction: null, translateInteraction: null });
    }
    return { modifyInteraction: null, translateInteraction: null, skipped: true };
  }

  if (oldModify) {
    map.removeInteraction(oldModify);
  }
  if (oldTranslate) {
    map.removeInteraction(oldTranslate);
  }

  const groupFeatures = groupSelection;
  const translateFeatureList = buildTranslateFeaturesFromSelection(
    groupFeatures?.getArray() ?? [],
    moduleSelection?.getArray() ?? []
  );
  const translateFeatures = new Collection(translateFeatureList);
  const stringFeatures = (groupFeatures?.getArray() ?? []).filter(
    f => (f.get('featureType') || '').toLowerCase() === 'string'
  );

  const translateInteraction = new Translate({
    features: translateFeatures,
    condition: event => !isMapTranslateBlockedEvent(event)
  });

  if (typeof handlers.onTranslateStart === 'function') {
    translateInteraction.on('translatestart', event => {
      handlers.onTranslateStart(event, stringFeatures);
    });
  }
  if (typeof handlers.onTranslating === 'function') {
    translateInteraction.on('translating', event => {
      handlers.onTranslating(event, stringFeatures);
    });
  }
  if (typeof handlers.onTranslateEnd === 'function') {
    translateInteraction.on('translateend', event => {
      handlers.onTranslateEnd(event, stringFeatures);
    });
  }

  map.addInteraction(translateInteraction);

  if (typeof assignInteractions === 'function') {
    assignInteractions({ modifyInteraction: null, translateInteraction });
  }

  return { modifyInteraction: null, translateInteraction };
}
